  import React, { useEffect, useState } from "react";
  import axios from "axios";
import { API_BASE_URL } from "../config/api";
  import {
    FaEdit,
    FaTrash,
    FaPlus,
    FaSearch,
    FaSort,
    FaArrowLeft,
    FaCalendarAlt,
    FaPhoneAlt,
    FaCheckCircle,
    FaChevronLeft,
    FaTimesCircle,
    FaChevronRight,
    FaSchool,
    FaEnvelope,
    FaTimes,
    FaImage, // Added FaTimes and FaImage
    FaFilter
  } from "react-icons/fa";
  import { motion, AnimatePresence } from "framer-motion";
  import Swal from "sweetalert2";
  import { useNavigate } from "react-router-dom";

  const imageFileAccept = ".jpg,.jpeg,.png,image/jpeg,image/png";
  const imageOnlyMessage = "Only JPG and PNG images are allowed. PDF, DOC, and Excel files are not allowed.";
  const isAllowedImageFile = (file) =>
    file &&
    ["image/jpeg", "image/png"].includes(file.type) &&
    /\.(jpe?g|png)$/i.test(file.name);

  function School() {
    const navigate = useNavigate();
    const [schools, setSchools] = useState([]);
    const [search, setSearch] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [uniforms, setUniforms] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [showModal, setShowModal] = useState(false);
    const [statusFilter, setStatusFilter] = useState("all");


    // New States to fix the errors
    const [isEditing, setIsEditing] = useState(false);
    const [productImages, setProductImages] = useState([]);
    const [sizeGuide, setSizeGuide] = useState(null);

    const [sortConfig, setSortConfig] = useState({
      key: "createdAt",
      direction: "desc",
    });

    // School Form Data
    const [formData, setFormData] = useState({
      name: "",
      address: "",
      email: "",
      phone: "",
      city: "",
      state: "",
    });

    const [form, setForm] = useState({
      name: "", // ⭐ ADD
      gender: "",
      house: "",
      description: "",
      price: "",
      sizeCategory: "",
      stock: 0,
    });

    const [editingId, setEditingId] = useState(null);

    // --- HELPERS ---
    const toast = (title, icon = "success") => {
      Swal.fire({
        title,
        icon,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    };

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    const getImageUrl = (imagePath) => {
      if (!imagePath) return "https://via.placeholder.com/75x75?text=No+Image";

      const cleanPath = String(imagePath)
        .replace(/\\/g, "/")
        .replace(/^\/+/, "");

      if (cleanPath.startsWith("http")) return cleanPath;
      if (cleanPath.startsWith("uploads/")) return `${API_BASE_URL}/${cleanPath}`;

      return `${API_BASE_URL}/uploads/${cleanPath}`;
    };

    const getPrimaryImage = (uniform) => {
      if (Array.isArray(uniform?.images) && uniform.images.length > 0) {
        return uniform.images[0];
      }

      return uniform?.image || "";
    };

    const handleManualStockToggle = async (id, currentStock) => {
      const isOutOfStock = currentStock <= 0;
      const actionText = isOutOfStock
        ? "Mark as IN STOCK?"
        : "Mark as OUT OF STOCK?";
      const confirmButtonColor = isOutOfStock ? "#10b981" : "#d33";

      Swal.fire({
        title: actionText,
        text: `This will update the inventory status for this item.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: confirmButtonColor,
        cancelButtonColor: "#6c757d",
        confirmButtonText: isOutOfStock ? "Yes, Set In-Stock" : "Yes, Mark Out",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Agar out of stock tha toh 100 kar denge, warna 0
          const newStock = isOutOfStock ? 100 : 0;
          try {
            await axios.put(`${API_BASE_URL}/uniform/${id}`, {
              stock: newStock,
            });
            fetchUniforms(selectedSchool._id);
            Swal.fire({
              icon: "success",
              title: isOutOfStock
                ? "Item is now back in stock"
                : "Item marked as out of stock",
            });
          } catch (err) {
            Swal.fire("Error", "Update failed", "error");
          }
        }
      });
    };

    const toggleAvailability = async (id) => {
    try {
      await axios.put(`${API_BASE_URL}/uniform/availability/${id}`);
      fetchUniforms(selectedSchool._id); // refresh the list
      Swal.fire({ icon: "success", title: "Availability updated" });
    } catch (err) {
      Swal.fire("Error", "Failed to update availability", "error");
    }
  };

    const openEditModal = (item) => {
      setIsEditing(true);
      setEditingId(item._id);
      setProductImages([]);

      setForm({
        name: item.name || "",
        gender: item.gender || "",
        house: item.house || "",
        description: item.description || "",
        price: item.price || "",
        sizeCategory: item.sizeCategory || "",
        stock: item.stock || 0,
      });

      setShowForm(true);
    };

    const closeModal = () => {
      setShowForm(false);
      setIsEditing(false);
      setEditingId(null);

      setForm({
        name: "",
        gender: "",
        house: "",
        description: "",
        price: "",
        sizeCategory: "",
        stock: 0,
      });

      setProductImages([]);
      setSizeGuide(null);
    };

    const fetchSchools = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/schools`);
        setSchools(res.data);
      } catch (err) {
        console.error("Error fetching schools", err);
      }
    };

  const fetchUniforms = async (schoolId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/uniform/by-school/${schoolId}`);
      console.log(res.data); // ✅ Add this to debug
      setUniforms(res.data);
    } catch (err) {
      console.error("Error fetching uniforms", err);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      
      // ✅ Backend route match karein: /schools/:id/active
      await axios.put(`${API_BASE_URL}/schools/${id}/active`, { 
        isActive: newStatus 
      });
      
      // ✅ State update mein 'isActive' field use karein
      setSchools(schools.map((item) => 
        item._id === id ? { ...item, isActive: newStatus } : item
      ));
      
      // Alert or Toast
      Swal.fire({
        icon: 'success',
        title: newStatus ? 'School Activated' : 'School Deactivated',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (err) {
      console.error("Status Update Error:", err);
      Swal.fire("Error", "Could not update status", "error");
    }
  };

    const handleChange = (e) => {
      const { name, value } = e.target;

      if (selectedSchool) {
        setForm({ ...form, [name]: value });
      } else {
        if (name === "phone") {
          const onlyNumbers = value.replace(/[^0-9]/g, "");
          if (onlyNumbers.length <= 10)
            setFormData({ ...formData, [name]: onlyNumbers });
        } else {
          setFormData({ ...formData, [name]: value });
        }
      }
    };

    const handleProductImagesChange = (e) => {
      const files = Array.from(e.target.files || []);
      const invalidFile = files.find((file) => !isAllowedImageFile(file));

      if (invalidFile) {
        e.target.value = "";
        setProductImages([]);
        Swal.fire("Invalid file", imageOnlyMessage, "warning");
        return;
      }

      setProductImages(files);
    };

    const handleSizeGuideChange = (e) => {
      const file = e.target.files?.[0] || null;

      if (file && !isAllowedImageFile(file)) {
        e.target.value = "";
        setSizeGuide(null);
        Swal.fire("Invalid file", imageOnlyMessage, "warning");
        return;
      }

      setSizeGuide(file);
    };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // --- 1️⃣ School Submission ---
    if (!selectedSchool) {
      if (formData.phone.length !== 10) {
        Swal.fire("Invalid Phone", "Phone number must be 10 digits!", "warning");
        return;
      }

      try {
        if (isEditing) {
          await axios.put(`${API_BASE_URL}/schools/${editingId}`, formData);
          Swal.fire({ icon: "success", title: "School Updated" });
        } else {
          await axios.post(`${API_BASE_URL}/schools`, formData);
          Swal.fire({
            icon: "success",
            title: "School Added!",
            text: "School saved successfully.",
            confirmButtonColor: "#10b981",
          });
        }
        fetchSchools();
        closeModal();
      } catch (err) {
        Swal.fire(
          "Error",
          err.response?.data?.message || "Could not save school.",
          "error"
        );
      }

    // --- 2️⃣ Uniform Submission ---
    } else {
      const formDataUpload = new FormData(); // ✅ declare inside else
      formDataUpload.append("schoolId", selectedSchool._id);

      Object.keys(form).forEach((key) => {
        formDataUpload.append(key, form[key]);
      });

      productImages.forEach((file) => formDataUpload.append("image", file));
      if (sizeGuide) formDataUpload.append("sizeGuide", sizeGuide);

      try {
        if (isEditing) {
          await axios.put(`${API_BASE_URL}/uniform/${editingId}`, formDataUpload);
          Swal.fire({ icon: "success", title: "Uniform Updated" });
        } else {
          await axios.post(`${API_BASE_URL}/uniform`, formDataUpload);
          Swal.fire({
            icon: "success",
            title: "Uniform Added",
            text: "New uniform added successfully!",
            confirmButtonColor: "#10b981",
          });
        }

        fetchUniforms(selectedSchool._id); // refresh uniforms list
        closeModal();
      } catch (err) {
        Swal.fire("Error", err.response?.data?.message || "Server error", "error");
      }
    }

    setShowModal(false);
  };

    const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "School and its uniforms will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/schools/${id}`);

        Swal.fire("Deleted!", "School has been removed.", "success");

        // UI se remove
        setSchools((prev) => prev.filter((s) => s._id !== id));

        // ⭐ IMPORTANT: backend se fresh data lao
        fetchSchools();

      } catch (error) {
        console.error("Delete Error:", error);
        Swal.fire(
          "Error!",
          error.response?.data?.message || "Failed to delete school.",
          "error"
        );
      }
    }
  };

    const requestSort = (key) => {
      let direction = "asc";
      if (sortConfig.key === key && sortConfig.direction === "asc")
        direction = "desc";
      setSortConfig({ key, direction });
    };

    // Pagination Logic
    const filteredSchools = schools
    .filter((s) => s.name.toLowerCase().includes(search.toLowerCase()))
    .filter((s) => {
      if (statusFilter === "active") return s.isActive;
      if (statusFilter === "inactive") return !s.isActive;
      return true;
    })
    .sort((a, b) => {
      let aVal = a[sortConfig.key] || "";
      let bVal = b[sortConfig.key] || "";

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;

      return 0;
    });

  const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentSchools = filteredSchools.slice(
      indexOfFirstItem,
      indexOfLastItem,
    );
    const currentUniforms = uniforms.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredSchools.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleEdit = (school) => {
      setFormData({ ...school });
      setEditingId(school._id);
      setIsEditing(true);
      setShowModal(true);
    };

    useEffect(() => {
      fetchSchools();
      setCurrentPage(1);
    }, [search]);

    return (
      <>
        <div className="p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
          <button
              className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent"
              onClick={() => navigate("/dashboard")}
            >
              <FaArrowLeft /> Back
            </button>
          <div className="d-flex justify-content-between align-items-center mb-4 p-3 bg-white shadow-sm rounded-4 border-start border-success border-5">
              <h3 className="fw-bold text-dark mb-0">School Management</h3>
              <div className="text-end pe-3">
                <h2 className="fw-bold mb-0" style={{ color: "#34a87b" }}>{schools.length}</h2>
                <span className="badge bg-light text-success border small">ACTIVE SCHOOLS</span>
              </div>
            </div>
          <div className="mx-auto" style={{ maxWidth: "1200px" }}>
            {selectedSchool ? (
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
              >
                <div className="row g-4">
                  <div className="col-lg-5">
                    <div className="card border-0 shadow-sm p-4 h-100 rounded-4 bg-white">
                      <div className="d-flex align-items-center gap-3 mb-4">
                        <div className="p-3 bg-light rounded-circle">
                          <FaSchool size={30} className="text-success" />
                        </div>
                        <div>
                          <h4 className="fw-bold text-success mb-0">
                            {selectedSchool.name}
                          </h4>
                          <small className="text-muted">
                            Code: {selectedSchool.schoolCode}
                          </small>
                        </div>
                      </div>
                    {/* ✅ Active / Inactive Status Section */}
                 <div className="d-flex justify-content-start mb-3 px-5 ">
 <span 
  className="badge d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
  style={{ 
    backgroundColor: selectedSchool?.isActive ? "#34a87b" : "#dc3545", 
    color: "white",
    borderRadius: "20px",
    fontSize: "11px",
    letterSpacing: "0.5px"
  }}
>
                        {selectedSchool?.isActive ? (
                          <>
                            <FaCheckCircle /> ACTIVE ACCOUNT
                          </>
                        ) : (
                          <>
                            <FaTimesCircle /> INACTIVE ACCOUNT
                          </>
                        )}
                      </span>
                    </div>
                      <button
                        className="btn btn-success w-100 mt-3 py-2 fw-bold"
                        style={{ borderRadius: "10px" }}
                        onClick={() => setShowForm(true)}
                      >
                        <FaPlus className="me-2" /> Add Uniform
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="card border-0 shadow-sm p-4 h-100 rounded-4 bg-white">
                      <div className="row g-4">
                        <div className="col-md-4">
                          <div className="info-item text-center p-2 border rounded">
                            <FaCalendarAlt className="text-primary mb-2" />
                            <p className="text-muted mb-0 x-small">
                              Active Items
                            </p>
                            <h6 className="fw-bold">{uniforms.length}</h6>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="info-item text-center p-2 border rounded">
                            <FaPhoneAlt className="text-primary mb-2" />
                            <p className="text-muted mb-0 x-small">Phone</p>
                            <h6 className="fw-bold" style={{ fontSize: "12px" }}>
                              {selectedSchool.phone || "N/A"}
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="info-item text-center p-2 border rounded">
                            <FaEnvelope className="text-primary mb-2" />
                            <p className="text-muted mb-0 x-small">Email</p>
                            <h6 className="fw-bold" style={{ fontSize: "11px" }}>
                              {selectedSchool.email}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <div className="row g-3">
                    <div className="mt-5">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="fw-bold d-flex align-items-center gap-2 m-0">
                          <div
                            style={{
                              width: "4px",
                              height: "20px",
                              background: "#097969",
                              borderRadius: "10px",
                            }}
                          ></div>
                          Uniform List
                        </h5>
                      </div>

                      <div className="row g-3">
                        {currentUniforms.length > 0 ? (
                          currentUniforms.map((u) => {
                            const primaryImage = getPrimaryImage(u);
                            const imageCount =
                              Array.isArray(u.images) && u.images.length > 0
                                ? u.images.length
                                : primaryImage
                                  ? 1
                                  : 0;

                            return (
                            <div className="col-md-6" key={u._id}>
                              <div
                                className={`card border-0 shadow-sm p-3 rounded-4 bg-white hover-up h-100 ${u.stock <= 0 ? "opacity-75" : ""}`}
                              >
                                <div className="d-flex align-items-center gap-3">
                                  <div className="position-relative">
                                    <img
                                      src={getImageUrl(primaryImage)}
                                      alt="Product"
                                      className="rounded-3 shadow-sm border"
                                      style={{
                                        width: 75,
                                        height: 75,
                                        objectFit: "cover",
                                      }}
                                    />
                                    {imageCount > 1 && (
                                      <span className="badge bg-dark text-white position-absolute bottom-0 end-0 m-1 x-small">
                                        {imageCount}
                                      </span>
                                    )}
                                    {u.stock <= 10 && u.stock > 0 && (
                                      <span className="badge bg-warning text-dark position-absolute top-0 start-0 m-1 x-small">
                                        Low
                                      </span>
                                    )}
                                  </div>
                                  <div className="flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <h6
                                          className="fw-bold mb-0 text-dark"
                                          style={{ fontSize: "0.95rem" }}
                                        >
                                          {u.name}
                                        </h6>
                                        <h6
                                          className="fw-bold mb-0 text-dark"
                                          style={{ fontSize: "0.95rem" }}
                                        >
                                          {u.house}
                                        </h6>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <FaEdit
                                          className="text-muted cursor-pointer"
                                          onClick={() => openEditModal(u)}
                                        />
                                        <FaTrash
                                          className="text-danger cursor-pointer"
                                          onClick={() => handleDelete(u._id)}
                                        />
                                        {/* Uniform List mapping ke andar */}
                                          <div>
    {/* Stock Toggle Button - Hamesha Clickable */}
    <button
      className={`btn w-100 py-1 rounded-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2 ${
        u.stock > 0 ? "btn-outline-success bg-white" : "btn-danger text-white"
      }`}
      onClick={() => handleManualStockToggle(u._id, u.stock)}
    >
      {u.stock > 0 ? "IN STOCK" : "OUT OF STOCK"}
    </button>

    {/* Available Button - Stock 0 par disabled */}
    {/* Available Button */}
  <button
    className={`btn btn-sm w-100 mt-2 ${
      u.isAvailable ? "btn-success" : "btn-secondary"
    }`}
    disabled={u.stock <= 0}
    onClick={() => toggleAvailability(u._id)}
  >
    {u.isAvailable ? "AVAILABLE" : "UNAVAILABLE"}
  </button>
  </div>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                      <span className="badge bg-light text-dark border px-3">
                                        ₹{u.price}
                                      </span>
                                      <span className="text-muted x-small">
                                        {u.gender}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            );
                          })
                        ) : (
                          <div className="col-12 text-center py-5">
                            <div className="p-4 bg-light rounded-4 text-muted">
                              No items found.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ) : (
            <>
    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

      <div className="d-flex gap-2">

        <div className="position-relative" style={{ width: "350px" }}>
          <FaSearch className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <input
            type="text"
            className="form-control ps-5 border-0 shadow-sm py-2"
            placeholder="Search school by name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ borderRadius: "10px" }}
          />
        </div>

        {/* FILTER DROPDOWN ADDED */}
        <div className="position-relative" style={{ width: "180px" }}>
          <FaFilter className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <select
            className="form-control ps-5 border-0 shadow-sm py-2"
            style={{ borderRadius: "10px" }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)} >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

      </div>

      <button
        className="btn btn-success px-4 py-2 d-flex align-items-center gap-2 shadow-sm border-0 btn school-btn"
        style={{ borderRadius: "10px" }}
        onClick={() => setShowModal(true)}
      >
        <FaPlus /> Add New School
      </button>

    </div>  

                <div className="table-responsive shadow-sm bg-white rounded-4 border">
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr style={{ color: "#111", fontSize: "16px" }}>
                        <th
                          className="py-3 px-4 border-0 pointer "
                          style={{ backgroundColor: "#edf9f5" }}
                          onClick={() => requestSort("name")}  >
                          School Name <FaSort size={10} />
                        </th>
                        <th className="py-3 border-0 text-center " style={{ backgroundColor: "#edf9f5" }}>
                          Location
                        </th>
                        <th className="py-3 border-0 text-center "  style={{ backgroundColor: "#edf9f5" }}>
                          Contact
                        </th>
                        <th className="py-3 border-0 text-center "  style={{ backgroundColor: "#edf9f5" }}>
                          Status
                        </th>
                        <th className="py-3 border-0 text-end px-4 "  style={{ backgroundColor: "#edf9f5" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentSchools.map((s) => (
                        <tr
                          key={s._id}
                          className="align-middle pointer"
                          onClick={() => {
                            setSelectedSchool(s);
                            fetchUniforms(s._id);
                          }}
                        >
                          <td className="py-3 px-4">
                            <div className="text-secondary" style={{fontSize:"15px"}}>{s.name}</div>
                            <small className="text-secondary">
                              CODE: {s.schoolCode || "N/A"}
                            </small>
                          </td>
                          <td className="text-center text-secondary">
                            {s.city}, {s.state}
                          </td>
                          <td className="text-center text-secondary">{s.phone}</td>
                      <td className="py-3 text-center">
    <div className="d-flex flex-column align-items-center gap-1">
      {/* s.isActive check karein */}
    <span 
    className="fw-bold" 
    style={{ fontSize: "11px", color: s.isActive ? "#34a87b" : "#dc3545" }}
  >
    {s.isActive ? (
      <><FaCheckCircle className="me-1" />ACTIVE</>
    ) : (
      <><FaTimesCircle className="me-1" />INACTIVE</>
    )}
  </span>

  <div className="form-check form-switch" onClick={(e) => e.stopPropagation()}>
    <input
      className="form-check-input pointer green-switch"
      type="checkbox"
      checked={!!s.isActive}
      onChange={() => toggleStatus(s._id, s.isActive)}
    />
      </div>
    </div>
  </td>
                          <td className="text-end px-4">
                            <button
                              className="btn btn-sm btn-light border me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(s);
                              }}
                            >
                              <FaEdit className="text-success" />
                            </button>
                            <button
                              className="btn btn-sm btn-light border"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(s._id);
                              }}
                            >
                              <FaTrash className="text-danger" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-between align-items-center p-3 bg-white border-top">
                    <span className="small text-muted">
                      Showing {indexOfFirstItem + 1} to{" "}
                      {Math.min(indexOfLastItem, filteredSchools.length)}
                    </span>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-light border"
                        disabled={currentPage === 1}
                        onClick={() => paginate(currentPage - 1)}
                      >
                        <FaChevronLeft />
                      </button>
                      <button className="btn btn-sm btn-success">
                        {currentPage}
                      </button>
                      <button
                        className="btn btn-sm btn-light border"
                        disabled={currentPage === totalPages}
                        onClick={() => paginate(currentPage + 1)}
                      >
                        <FaChevronRight />
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {!selectedSchool ? (
            <AnimatePresence>
              {showModal && (
                <div
                  className="custom-modal-overlay d-flex align-items-center justify-content-center"
                  onClick={() => setShowModal(false)}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 1050,
                    padding: "20px",
                  }}
                >
                  <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                    className="w-100" // Full width of the container
                    style={{ maxWidth: "600px" }} // Isse width control hogi
                    onClick={(e) => e.stopPropagation()}
                  >
                    <form
                      onSubmit={handleSubmit}
                      className="card card-body border-0 shadow-lg p-4 rounded-4"
                      style={{ backgroundColor: "white" }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                        <h5 className="fw-bold text-success m-0">
                          {editingId
                            ? "✏️ Update School Information"
                            : "🏫 Register New School"}
                        </h5>

                        <button
                          type="button"
                          className="btn btn-light rounded-circle"
                          onClick={() => setShowModal(false)}
                        >
                          <FaTimes />
                        </button>
                      </div>

                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label small fw-bold text-muted">
                            School Name
                          </label>
                          <input
                            name="name"
                            className="form-control bg-light border-0 py-2"
                            placeholder="E.g. Green Valley High"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label small fw-bold text-muted">
                            Phone Number
                          </label>
                          <input
                            name="phone"
                            type="text"
                            maxLength="10"
                            className="form-control bg-light border-0 py-2"
                            placeholder="10 digit number"
                            value={formData.phone}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, "");
                              setFormData({ ...formData, phone: val });
                            }}
                            required
                          />
                        </div>

                        <div className="col-md-12">
                          <label className="form-label small fw-bold text-muted">
                            Email Address
                          </label>
                          <input
                            name="email"
                            type="email"
                            className="form-control bg-light border-0 py-2"
                            placeholder="school@example.com"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label small fw-bold text-muted">
                            City
                          </label>
                          <input
                            name="city"
                            className="form-control bg-light border-0 py-2"
                            placeholder="City"
                            value={formData.city}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label small fw-bold text-muted">
                            State
                          </label>
                          <input
                            name="state"
                            className="form-control bg-light border-0 py-2"
                            placeholder="State"
                            value={formData.state}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label small fw-bold text-muted">
                            Full Address
                          </label>
                          <textarea
                            name="address"
                            className="form-control bg-light border-0"
                            rows="2"
                            placeholder="Street address..."
                            value={formData.address}
                            onChange={handleChange}
                          ></textarea>
                        </div>

                        <div className="col-12 mt-4">
                          <button
                            type="submit"
                            className="btn  w-100 py-2 fw-bold shadow-sm border-0"
                            style={{ backgroundColor: "#097969" ,color:"white"}}
                          >
                            {editingId ? "Update Record" : "Save School"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </motion.div>
                </div>
              )}
            </AnimatePresence>
          ) : (
            <AnimatePresence>
              {showForm && (
                <div className="custom-modal-overlay">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    className="custom-modal-card"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="fw-bold m-0 text-dark">
                        {isEditing ? "Update Uniform" : "Add Uniform Item"}
                      </h5>
                      <button
                        className="btn btn-light rounded-circle p-2"
                        onClick={closeModal}
                      >
                        <FaTimes />
                      </button>
                    </div>
                    <form onSubmit={handleSubmit} className="row g-4 p-3">
                      {/* --- SECTION: BASIC INFO --- */}
                      <div className="col-12">
                        <h6
                          className="text-uppercase text-muted fw-bold mb-3"
                          style={{ fontSize: "12px", letterSpacing: "1px" }}
                        >
                          Basic Information
                        </h6>
                      </div>

                      <div className="col-md-6">
                        <label className="small fw-bold mb-2 text-secondary">
                          Uniform Title
                        </label>
                        <div className="input-group border-0 shadow-sm rounded-3 overflow-hidden">
                          <input
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="e.g. DPS Summer Shirt"
                            className="form-control border-0 bg-white py-2 px-3"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="small fw-bold mb-2 text-secondary">
                          House
                        </label>
                        <input
                          name="house"
                          value={form.house}
                          placeholder="e.g. Red House / General"
                          className="form-control border-0 bg-white shadow-sm py-2 px-3"
                          onChange={handleChange}
                          required
                          style={{ borderRadius: "10px" }}
                        />
                      </div>

                      {/* --- SECTION: CATEGORY & PRICING --- */}
                      <div className="col-md-6">
                        <label className="small fw-bold mb-2 text-secondary">
                          Category (e.g. Pant, Tie)
                        </label>
                        <input
                          type="text"
                          name="sizeCategory"
                          value={form.sizeCategory}
                          onChange={handleChange}
                          placeholder="e.g. Pant, Tie, Shirt"
                          className="form-control border-0 bg-white shadow-sm py-2 px-3"
                          style={{ borderRadius: "10px" }}
                          required
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="small fw-bold mb-2 text-secondary">
                          Price (₹)
                        </label>
                        <div
                          className="input-group shadow-sm"
                          style={{ borderRadius: "10px", overflow: "hidden" }}
                        >
                          <span className="input-group-text border-0 bg-white text-muted">
                            ₹
                          </span>
                          <input
                            name="price"
                            value={form.price}
                            type="number"
                            className="form-control border-0 bg-white py-2"
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="small fw-bold mb-2 text-secondary">
                          Stock Quantity
                        </label>
                        <input
                          name="stock"
                          type="number"
                          value={form.stock}
                          placeholder="0"
                          className="form-control border-0 bg-white shadow-sm py-2 no-number-spinner"
                          onChange={handleChange}
                          style={{ borderRadius: "10px" }}
                        />
                      </div>

                      {/* --- SECTION: SPECIFICATIONS --- */}
                      <div className="col-md-4">
                        <label className="small fw-bold mb-2 text-secondary">
                          Gender
                        </label>
                        <select
                          name="gender"
                          value={form.gender}
                          className="form-select border-0 bg-white shadow-sm py-2"
                          onChange={handleChange}
                          style={{ borderRadius: "10px" }}
                        >
                          <option value="">Select Gender</option>
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                      </div>


                      <div className="col-md-8">
                        <label className="small fw-bold mb-2 text-secondary">
                          Description
                        </label>
                        <textarea
                          name="description"
                          value={form.description}
                          rows="3"
                          placeholder="Write details about material, fabric, etc."
                          className="form-control border-0 bg-white shadow-sm p-3"
                          onChange={handleChange}
                          style={{ borderRadius: "15px" }}
                        ></textarea>
                      </div>

                      {/* --- SECTION: MEDIA UPLOAD --- */}
                      <div className="col-md-6">
                        <div
                          className="p-3 bg-white shadow-sm"
                          style={{
                            borderRadius: "15px",
                            border: "1px dashed #dee2e6",
                          }}
                        >
                          <label className="small fw-bold mb-2 d-block">
                            <FaImage className="me-2 text-success" /> Product
                            Images
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-sm border-0 bg-light"
                            accept={imageFileAccept}
                            multiple
                            onChange={handleProductImagesChange}
                          />
                          <small className="text-muted d-block mt-2">
                            {productImages.length > 0
                              ? `${productImages.length} image${productImages.length > 1 ? "s" : ""} selected`
                              : isEditing
                                ? "Select new images only if you want to replace current product images."
                                : "You can select multiple product photos."}
                          </small>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div
                          className="p-3 bg-white shadow-sm"
                          style={{
                            borderRadius: "15px",
                            border: "1px dashed #dee2e6",
                          }}
                        >
                          <label className="small fw-bold mb-2 d-block">
                            <FaImage className="me-2 text-primary" /> Size Guide
                            Chart
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-sm border-0 bg-light"
                            accept={imageFileAccept}
                            onChange={handleSizeGuideChange}
                          />
                        </div>
                      </div>

                      {/* --- SUBMIT BUTTON --- */}
                      <div className="col-12 mt-4">
                        <button
                          type="submit"
                          className="btn btn-success w-100 py-3 fw-bold border-0 shadow-lg"
                          style={{
                            borderRadius: "15px",
                            background:
                              "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            transition: "transform 0.2s ease",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.transform = "translateY(-2px)")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.transform = "translateY(0)")
                          }
                        >
                          {isEditing
                            ? "🚀 Update Uniform Details"
                            : "✅ Save to Inventory"}
                        </button>
                      </div>
                    </form>
                  </motion.div>
                </div>
              )}
            </AnimatePresence>
          )}
        </div>
        <style>{`
          .custom-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(8px); display: flex; justify-content: center; align-items: center; z-index: 9999; }
          .custom-modal-card { background: white; padding: 30px; border-radius: 25px; width: 95%; max-width: 600px; box-shadow: 0 20px 40px rgba(0,0,0,0.1); max-height: 90vh; overflow-y: auto; }
          .x-small { font-size: 11px; }
          .profile-img-placeholder { width: 50px; height: 50px; background: #e8f5e9; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
          .profile-circle { width: 70px; height: 70px; background: #f8f9fa; border: 2px solid #eee; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
          .hover-up:hover { transform: translateY(-5px); transition: 0.3s; box-shadow: 0 15px 30px rgba(0,0,0,0.08) !important; }
          .cursor-pointer { cursor: pointer; }
        `}</style>
      </>
    );
  }

  export default School;
